import Section from 'layouts/Section/Section';

import Title from 'components/Title/Title';

import BenefitsAccordion from './BenefitsAccordion';
import config from './list';

const BenefitsSection = () => {
  return (
    <Section>
      <Title title="A Business Model That Benefits All">
        A synergistic approach that connects job seekers, employers, and
        nations, promoting shared success and opportunity for all.
      </Title>
      <BenefitsAccordion items={config} />
    </Section>
  );
};

export default BenefitsSection;
